import React from "react";
import { TooltipWrapper } from "@workspace/common";
import { useSelector } from "react-redux";

function BGCStatusCounts({ setStatus }) {
  const preOfferCounts = useSelector(
    (state) => state.PreOfferCandidateReducer.counts
  );
  const bgcCounts = useSelector(
    (state) => state.PreOfferCandidateReducer.bgcCounts
  );

  return (
    <div className="d-flex flex-row justify-content-between mb-2">
      <div style={{ width: "20%" }}>
        <span className="elc-tile-title">BGC</span>
      </div>
      {/* Accepted Count */}
      <TooltipWrapper tooltipText="BGC Completed">
        <div style={{ width: "20%" }}>
          <div
            className="d-flex flex-row align-items-center justify-content-start gap-2 cursor-pointer"
            onClick={() => setStatus("BGC_COMPLETED")}
          >
            <div className="approved-count-circle">
              <span className="mdi mdi-check elc-check-icon"></span>
            </div>
            <span className="approved-count">
              {bgcCounts?.completedBGC ?? 0}
            </span>
          </div>
        </div>
      </TooltipWrapper>
      {/* Pending Count */}
      <TooltipWrapper tooltipText="BGC Pending">
        <div style={{ width: "20%" }}>
          <div
            className="d-flex flex-row align-items-center justify-content-start gap-2 cursor-pointer"
            onClick={() => setStatus("BGC_PENDING")}
          >
            <div className="pending-count-circle">
              <span className="mdi mdi-message-alert-outline elc-pending-icon"></span>
            </div>
            <span className="pending-count">{bgcCounts?.pendingBGC ?? 0}</span>
          </div>
        </div>
      </TooltipWrapper>
      {/* In Progress Count */}
      <TooltipWrapper tooltipText="BGC In Progress">
        <div style={{ width: "20%" }}>
          <div
            className="d-flex flex-row align-items-center justify-content-start gap-2 cursor-pointer"
            onClick={() => setStatus("BGC_IN_PROGRESS")}
          >
            <div className="revised-count-circle">
              <span className="mdi mdi-run-fast elc-revised-icon"></span>
            </div>
            <span className="revised-count">
              {preOfferCounts?.bgcInProgressCount ?? 0}
            </span>
          </div>
        </div>
      </TooltipWrapper>
      {/* Rejected Count */}
      <TooltipWrapper tooltipText="BGC Rejected">
        <div style={{ width: "20%" }}>
          <div
            className="d-flex flex-row align-items-center gap-2 cursor-pointer"
            onClick={() => setStatus("BGC_REJECTED")}
          >
            <div className="rejected-count-circle">
              <span className="mdi mdi-alert-circle-outline elc-rejected-icon"></span>
            </div>
            <span className="rejected-count">
              {preOfferCounts?.bgcRejectedCount ?? 0}
            </span>
          </div>
        </div>
      </TooltipWrapper>
      {/* SLA Count */}
      <TooltipWrapper tooltipText="SLA">
        <div style={{ width: "20%" }}>
          <div className="d-flex flex-row align-items-center gap-2 cursor-pointer">
            <div className="sla-count-circle">
              <span className="mdi mdi-clock-alert-outline elc-alert-icon"></span>
            </div>
            <span className="sla-count">
              {preOfferCounts?.correctionNeededCount ?? 0}
            </span>
          </div>
        </div>
      </TooltipWrapper>
    </div>
  );
}

export default BGCStatusCounts;
